import ClassNames from "classnames";
import * as React from "react";

import LoadingIcon from "../_assets/icon-spinner.svg";
import Styles from "./Loader.module.css";

export interface Props {
  className?: string;
  size?: number;
}

const Loader: React.FC<Props> = props => {
  const { className, size = 68 } = props;

  return (
    <div
      className={ClassNames({
        [Styles.spinner]: true,
        [className]: className
      })}
      style={{ width: size, height: size }}
    >
      <span role="alert" aria-busy="true" className="sr-only">
        Loading
      </span>
      <LoadingIcon is="svg" />
    </div>
  );
};

export default Loader;
